import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { basePageWrap } from '../BasePage';
import styles from './ArticlePage.module.scss';

import ArticleEntry from '../../components/ArticleEntry';
import RichText from '../../components/RichText';
import HeroSlim from '../../components/HeroSlim';
import StreamField from '../../components/StreamField';
import { trackEvent } from '../../utils/datalayer';
import Contact from '../../components/Contact';

class ArticlePage extends PureComponent {
    state = {};

    static defaultProps = {
        articleEntry: {},
        articleHero: null,
        richText: null,
        extendedRichText: [],
        contact: {},
        collaborationBody: {},
    };

    static propTypes = {
        articleEntry: PropTypes.object.isRequired,
        articleHero: PropTypes.object,
        richText: PropTypes.object,
        extendedRichText: PropTypes.array,
        contact: PropTypes.object,
        collaborationBody: PropTypes.object,
    };

    componentDidMount() {
        trackEvent('PageView', 'PageType', 'ArticlePage', 'ArticlePage');
    }

    render() {
        const {
            hero,
            articleEntry,
            richText,
            extendedRichText,
            contact,
            collaborationBody,
        } = this.props;

        return (
            <div className={styles['ArticlePage']}>
                <main className={styles['ArticlePage__Main']}>
                    {hero && <HeroSlim {...hero} />}

                    <article
                        className={
                            styles['ArticlePage__Section'] +
                            ' ' +
                            styles['ArticlePage__Section--Grid']
                        }>
                        <div className={styles['ArticlePage__Content']}>
                            <div className={styles['ArticlePage__Row']}>
                                {articleEntry && (
                                    <div
                                        className={
                                            styles[
                                                'ArticlePage__EntryWrapperGrid'
                                            ]
                                        }>
                                        <ArticleEntry
                                            {...articleEntry}
                                            categories={null}
                                            displayActions={true}
                                            collaboration={collaborationBody}
                                        />
                                    </div>
                                )}

                                <section
                                    className={styles['ArticlePage__RichText']}>
                                    {richText && <RichText {...richText} />}
                                    {!!extendedRichText &&
                                        !!extendedRichText.length && (
                                            <StreamField
                                                items={extendedRichText}
                                            />
                                        )}
                                </section>
                            </div>
                        </div>
                        {contact?.fullName && (
                            <div
                                className={
                                    styles['ArticlePage__ContactWrapper'] +
                                    ' ' +
                                    styles['ArticlePage__ContactWrapper--Grid']
                                }>
                                <Contact {...contact} />
                            </div>
                        )}
                    </article>
                </main>
            </div>
        );
    }
}

export default basePageWrap(ArticlePage);
